"use client";

import type { ElementType, ReactNode } from "react";

export type GradientVariant = "brand" | "accent" | "divider";

type GradientTextProps = {
  children: ReactNode;
  className?: string;
  /**
   * 'brand' = cyan -> blue -> purple (hero headline, primary emphasis).
   * 'accent' = blue -> purple (secondary emphasis).
   * 'divider' = cyan -> purple, 2-stop (thin accent rules/underlines).
   * Maps to the `bg-brand-gradient*` utilities in tailwind.config.js.
   */
  variant?: GradientVariant;
  as?: ElementType;
};

const GRADIENT_CLASS: Record<GradientVariant, string> = {
  brand: "bg-brand-gradient",
  accent: "bg-brand-gradient-accent",
  divider: "bg-brand-gradient-divider",
};

/**
 * Gradient clip-text, shared by every "Reqrium"-style headline/emphasis span
 * across the app. Centralizes the brand gradient so it's defined once (in
 * tailwind.config.js) instead of re-typed as an inline `backgroundImage`
 * string per component.
 */
export default function GradientText({ children, className = "", variant = "brand", as: Tag = "span" }: GradientTextProps) {
  return <Tag className={`${GRADIENT_CLASS[variant]} bg-clip-text text-transparent ${className}`}>{children}</Tag>;
}
